module.exports = __webpack_public_path__ + "img/jiagoutop.6cfd369f.jpg";